import $ from 'jquery';
import intlTelInput from 'intl-tel-input';

const intlPhoneField = () => {
	const el = {
		id_phone_number: '.elementor-field-type-tel.elementor-field-group input',
	};
	const init = () => {
		window.addEventListener('elementor/frontend/init', function () {
			// eslint-disable-next-line no-undef
			elementorFrontend.hooks.addAction('frontend/element_ready/form.default', function ($scope) {
				if (!$(el.id_phone_number).length) return;

				exec($scope);
			});
		});
	};

	const exec = ($scope) => {
		let input;

		setTimeout(() => {
			input = $scope.find(el.id_phone_number).get(0);

			intlTelInput(input, {
				loadUtilsOnInit: () => import('intl-tel-input/utils'),
			});
		}, 100);
	};

	init();
};

try {
	intlPhoneField();
} catch (error) {
	console.error(error);
}
